import { memo } from 'react';

import { PaneContainer } from '~/components/FileStatusTrackingPane/PaneContainer';
import { type VideoClipTask } from '~/components/VideoClipTasks/types';
import { VideoClipTaskPanelItemCompleted } from '~/components/VideoClipTasks/VideoClipTaskPanelItemCompleted';
import { VideoClipTaskPanelItemFailed } from '~/components/VideoClipTasks/VideoClipTaskPanelItemFailed';
import { VideoClipTaskPanelItemInProgress } from '~/components/VideoClipTasks/VideoClipTaskPanelItemInProgress';

export type VideoClipTasksPanelProps = {
  tasks: VideoClipTask[];
  onCancel: (localTaskId: string) => void;
  onClear: (localTaskId: string) => void;
};

export const VideoClipTasksPanel = memo(({ tasks, onCancel, onClear }: VideoClipTasksPanelProps) => {
  return (
    <div data-testid="VIDEO_CLIP_TASK_PANEL">
      {tasks.map((task) => {
        return (
          <PaneContainer key={task.localTaskId} className="mb-2 last:mb-0">
            {task.status === 'in-progress' || task.status === 'pending' ? (
              <VideoClipTaskPanelItemInProgress metadata={task.metadata} onCancel={() => onCancel(task.localTaskId)} />
            ) : null}
            {task.status === 'completed' ? (
              <VideoClipTaskPanelItemCompleted metadata={task.metadata} onClear={() => onClear(task.localTaskId)} />
            ) : null}
            {task.status === 'error' ? (
              <VideoClipTaskPanelItemFailed metadata={task.metadata} onClear={() => onClear(task.localTaskId)} />
            ) : null}
          </PaneContainer>
        );
      })}
    </div>
  );
});

VideoClipTasksPanel.displayName = 'VideoClipTasksPanel';
